import { TariffEntity } from 'backend-entity';

export type CrmPatchTariffRequestDto = Omit<
  Partial<TariffEntity>,
  'id' | 'createdAt' | 'updatedAt' | 'durationDays' | 'currency'
>;
